import { c as _c } from "react/compiler-runtime";
import { Stack } from "@mui-wrapper";
import { FontWeights } from "@flat-ui";
import { withEllipsisThreeLines } from "@styles/common-styles";
import { useDynamicHeight } from "@hooks/use-dynamic-height";
/** Defines the size of the icon in pixels */
const ICON_SIZE = "61px";

/** Since the colors or this page are custom, store them here to modify them easily */
const pageColors = {
  /** The background color of the whole empty page */
  pageBackground: "surfaces.secondary",
  /** The color of the title text */
  title: "text.primary",
  /** The color of the subtitle text */
  subtitle: "text.secondary"
};

/**
 * Shows an empty page with an icon, title and subtitle.
 */
export function EmptyPage(t0) {
  const $ = _c(19);
  const {
    title,
    subtitle,
    icon,
    button
  } = t0;
  const Icon = icon;
  const {
    ref,
    height
  } = useDynamicHeight();
  let t1;
  if ($[0] !== height) {
    t1 = {
      height,
      backgroundColor: pageColors.pageBackground,
      textAlign: "center",
      px: 2,
      overflow: "hidden",
      justifyContent: "center",
      alignItems: "center",
      gap: 3
    };
    $[0] = height;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      justifyContent: "center"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      width: "178px",
      height: "178px",
      backgroundColor: "background.paper",
      borderRadius: "50%",
      justifyContent: "center",
      alignItems: "center"
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      height: ICON_SIZE,
      width: ICON_SIZE
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== Icon) {
    t5 = <Stack sx={t2}><Stack sx={t3}><Icon sx={t4} /></Stack></Stack>;
    $[5] = Icon;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      fontSize: "24px",
      fontWeight: FontWeights.SemiBold,
      color: pageColors.title,
      maxWidth: "90%",
      ...withEllipsisThreeLines,
      lineHeight: "2rem",
      justifyContent: "center"
    };
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== title) {
    t7 = <Stack sx={t6}>{title}</Stack>;
    $[8] = title;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== subtitle) {
    t8 = subtitle && <Stack sx={{
      fontSize: "1rem",
      color: pageColors.subtitle,
      maxWidth: "90%",
      ...withEllipsisThreeLines,
      justifyContent: "center"
    }}>{subtitle}</Stack>;
    $[10] = subtitle;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== button || $[13] !== ref || $[14] !== t1 || $[15] !== t5 || $[16] !== t7 || $[17] !== t8) {
    t9 = <Stack ref={ref} sx={t1} data-testid="empty-page-container">{t5}{t7}{t8}{button}</Stack>;
    $[12] = button;
    $[13] = ref;
    $[14] = t1;
    $[15] = t5;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
}